import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getImage, warrantyClaim } from "../services/Tools";
import { getProductById, getServiceCentersList } from "../services/apiService";
import { withImageVersion } from "../contextApi/ImageVersionContext";

const WarrantyClaim = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const warranty = state;
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState({});
    const [isProductUploading, setIsProductUploading] = useState(false);
    const [responseProductFile, setResponseProductFile] = useState("");
    const [errors, setErrors] = useState({});
    const [mainImage, setMainImage] = useState("");
    const [serviceCenters, setServiceCenters] = useState([]);

    const [verifiedProduct, setVerifiedProduct] = useState(warranty || null);
    const [productid, setProductId] = useState(warranty?.productid || null);
    const scrollToProductTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const [form, setForm] = useState({
        userid: localStorage.getItem("userId") || "",
        productimage: "",
        discription: "",
        servicecenter: "",
        machinePowerOn: "",
        machineDisplayError: "",
        errorCode: "",
        physicalDamage: "",
        voltageIssue: "",
        weldingOutput: "",
    });
    useEffect(() => {
        if (warranty) {
            console.log("Warranty Record:", warranty);
            setVerifiedProduct(warranty);
            setProductId(warranty.productid);
        }
    }, [warranty]);

    useEffect(() => {
        if (!productid) return;
        setLoading(true);
        getProductById(productid)
            .then((res) => {
                const p = { ...res.data[0], qty: 0 };
                setProduct(p);
                console.log("Product Data:", p);
                setMainImage(p.image1);

                // Scroll to top when product loads
                setTimeout(scrollToProductTop, 100);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching product:", err);
                setLoading(false);
            });
    }, [productid]);

    useEffect(() => {
        getServiceCentersList()
            .then((res) => {
                setServiceCenters(res?.data || res || []);
            })
            .catch((err) => {
                console.error("Error fetching service centers:", err);
            });
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const uploadImage = async ({ image, filePath }) => {
        setIsProductUploading(true);

        try {
            const filename = filePath.split("/").pop();
            const uploadResponse = await getImage({
                filename,
                image,
                userid: form.userid,
                processes: "warranty",
            });

            const imageUrl =
                uploadResponse?.image ||
                uploadResponse?.data?.imageurl ||
                uploadResponse?.imageurl ||
                uploadResponse?.url;

            if (imageUrl) {
                setResponseProductFile(imageUrl);
                setForm((prev) => ({ ...prev, productimage: imageUrl }));
                return imageUrl;
            } else {
                showSnackbar("error", "Image upload failed.");
                return null;
            }
        } catch (error) {
            showSnackbar("error", "Image upload failed.");
            return null;
        } finally {
            setIsProductUploading(false);
        }
    };

    const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
    ];

    const handleFileUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        if (file.size > 2 * 1024 * 1024) {
            showSnackbar("error", "File size should be less than 2MB");
            return;
        }

        if (!allowedTypes.includes(file.type)) {
            showSnackbar("error", "Please upload a JPG, JPEG, PNG, or PDF file");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64 = reader.result;
            await uploadImage({
                image: base64,
                filePath: file.name,
            });
        };
        reader.readAsDataURL(file);
    };

    const validate = () => {
        const newErrors = {};
        if (!form.discription?.trim())
            newErrors.discription = "Description is required";
        if (!responseProductFile)
            newErrors.productimage = "Warranty card image is required";
        return newErrors;
    };

    const submitWarranty = async (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            showSnackbar("error", "Please fill all required fields");
            return;
        }

        setSubmitting(true);
        //  warrantyid ,
        //     date,
        //     userid ,
        //     clientid ,
        //     image ,
        //     discription,
        //     isapproval ,
        //     approvaluserid,
        const payload = {
            warrantyid: Number(verifiedProduct?.warrantyid) || 0,
            date: new Date().toISOString().split("T")[0],
            userid: Number(form.userid) || 0,
            image: responseProductFile,
            discription: form.discription,
            servicecenter: form.servicecenter || "",
            machinePowerOn: form.machinePowerOn || "",
            machineDisplayError: form.machineDisplayError || "",
            errorCode: form.errorCode || "",
            physicalDamage: form.physicalDamage || "",
            voltageIssue: form.voltageIssue || "",
            weldingOutput: form.weldingOutput || "",

        };

        try {
            const response = await warrantyClaim(payload);

            if (response?.status === true || response?.success) {
                navigate("/");
            } else {
                showSnackbar("error", "Something went wrong during warranty submission.");
            }
        } catch (error) {
            showSnackbar("error", "Failed to submit warranty to the server.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="warranty-container">
            <div className="row justify-content-center">
                {verifiedProduct && (
                    <div className="col-md-6 col-lg-8 mb-4">
                                    {/* <h2 style={{justifyContent:'center',alignItems:'center'}}>Warranty Claim</h2> */}

                        <div className="product-details-card">
                            <div className="product-details-header">
                                {/* <h4>Product Details</h4> */}
                            </div>
                            <div className="product-details-body">
                                <div className="product-details-image">
                                    <img
                                        src={withImageVersion(mainImage || product?.image1)}
                                        alt={product?.displaymodelno || "Product"}
                                    />
                                </div>
                                <div className="product-details-info">
                                    <div className="product-details-row">
                                        <span className="detail-label">Product ID</span>
                                        <span className="detail-value">{verifiedProduct.productid}</span>
                                    </div>
                                    <div className="product-details-row">
                                        <span className="detail-label">Model No</span>
                                        <span className="detail-value">{verifiedProduct.modelno}</span>
                                    </div>
                                    <div className="product-details-row">
                                        <span className="detail-label">Category</span>
                                        <span className="detail-value">{verifiedProduct.category}</span>
                                    </div>
                                    <div className="product-details-row">
                                        <span className="detail-label">Subcategory</span>
                                        <span className="detail-value">{product.subcategory}</span>
                                    </div>
                                    <div className="product-details-row">
                                        <span className="detail-label">Brand</span>
                                        <span className="detail-value">{product.brand}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-md-10 col-lg-8 mb-4">
                    <form onSubmit={submitWarranty} className="warranty-form">



                        <div className="form-row">

                            <div className="form-group form-group-full">
                                <label className="form-label">
                                    Service Center
                                </label>
                                <select
                                    className="form-control"
                                    name="servicecenter"
                                    value={form.servicecenter}
                                    onChange={handleChange}
                                >
                                    <option value="">Select a service center</option>
                                    {serviceCenters.map((center, idx) => (
                                        <option key={center.id || idx} value={center.id || center.name}>
                                            {center.first_name || center.centername || center}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group form-group-full">
                                <label className="form-label" style={{ fontSize: "16px", fontWeight: "600", marginTop: "8px", display: "block" }}>
                                    Diagnostic Questions
                                </label>

                                <div style={{ marginBottom: "16px" }}>
                                    <p style={{ margin: "0 0 8px", fontWeight: "500" }}>Is the welding machine powering ON and functioning properly?</p>
                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="machinePowerOn" value="Yes" checked={form.machinePowerOn === "Yes"} onChange={handleChange} /> Yes
                                        </label>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="machinePowerOn" value="No" checked={form.machinePowerOn === "No"} onChange={handleChange} /> No
                                        </label>
                                    </div>
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                    <p style={{ margin: "0 0 8px", fontWeight: "500" }}>Is the machine display showing any error code, abnormal indication, or no display?</p>
                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "center" }}>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="machineDisplayError" value="Yes" checked={form.machineDisplayError === "Yes"} onChange={handleChange} /> Yes
                                        </label>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="machineDisplayError" value="No" checked={form.machineDisplayError === "No"} onChange={handleChange} /> No
                                        </label>
                                    </div>
                                    {form.machineDisplayError === "Yes" && (
                                        <div style={{ marginTop: "8px" }}>
                                            <input
                                                type="text"
                                                name="errorCode"
                                                value={form.errorCode}
                                                onChange={handleChange}
                                                placeholder="Mention the error code"
                                                className="form-control"
                                                style={{ maxWidth: "300px" }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                    <p style={{ margin: "0 0 8px", fontWeight: "500" }}>Is there any physical damage, burning, crack, broken part, or damage to the machine body/cable?</p>
                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="physicalDamage" value="Yes" checked={form.physicalDamage === "Yes"} onChange={handleChange} /> Yes
                                        </label>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="physicalDamage" value="No" checked={form.physicalDamage === "No"} onChange={handleChange} /> No
                                        </label>
                                    </div>
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                    <p style={{ margin: "0 0 8px", fontWeight: "500" }}>Has the machine experienced any high-voltage, low-voltage, voltage fluctuation, or electrical supply issue?</p>
                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="voltageIssue" value="Yes" checked={form.voltageIssue === "Yes"} onChange={handleChange} /> Yes
                                        </label>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="voltageIssue" value="No" checked={form.voltageIssue === "No"} onChange={handleChange} /> No
                                        </label>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                            <input type="radio" name="voltageIssue" value="Not Sure" checked={form.voltageIssue === "Not Sure"} onChange={handleChange} /> Not Sure
                                        </label>
                                    </div>
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                    <p style={{ margin: "0 0 8px", fontWeight: "500" }}>Is the machine producing proper welding output, or is there any issue such as low output, no output, unstable arc, or excessive sparking?</p>
                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                        {["Proper", "Low Output", "No Output", "Unstable Arc", "Sparking"].map((opt) => (
                                            <label key={opt} style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", margin: 0 }}>
                                                <input type="radio" name="weldingOutput" value={opt} checked={form.weldingOutput === opt} onChange={handleChange} /> {opt}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group form-group-full">
                                <label className="form-label">
                                    Description <span className="required">*</span>
                                </label>
                                <textarea
                                    className={`form-control ${errors.discription ? "is-invalid" : ""}`}
                                    name="discription"
                                    value={form.discription}
                                    onChange={handleChange}
                                    placeholder="Describe your issue or reason for warranty claim"
                                    rows="4"
                                    style={{ resize: "vertical" }}
                                />
                                {errors.discription && (
                                    <div className="invalid-feedback">{errors.discription}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    Upload Warranty Card (max 2Mb) <span className="required">*</span>
                                </label>
                                <div className="file-input-wrapper">
                                    <input
                                        type="file"
                                        id="productFile"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        disabled={isProductUploading}
                                    />
                                    <label htmlFor="productFile" className="file-input-label">
                                        <span>
                                            {form.productimage
                                                ? "Warranty card uploaded"
                                                : "Click to upload warranty card"}
                                        </span>
                                    </label>
                                </div>
                                {isProductUploading && (
                                    <div className="file-uploading">
                                        <span className="spinner-border spinner-border-sm"></span>
                                        Uploading warranty card...
                                    </div>
                                )}
                                {responseProductFile && !isProductUploading && (
                                    <div className="file-preview">
                                        <div className="file-name">✓ Warranty card uploaded successfully</div>
                                        <img
                                            src={responseProductFile}
                                            alt="Warranty Card"
                                            style={{
                                                width: "180px",
                                                height: "180px",
                                                objectFit: "cover",
                                                border: "1px solid #ddd",
                                                borderRadius: "8px",
                                                marginTop: "10px",
                                            }}
                                        />
                                    </div>
                                )}
                                {errors.productimage && (
                                    <div className="invalid-feedback">
                                        {errors.productimage}
                                    </div>
                                )}
                            </div>
                        </div>



                        <div className="text-center mt-4">
                            <button
                                type="submit"
                                className="btn btn-warranty-submit"
                                disabled={
                                    submitting || isProductUploading
                                }
                            >
                                {submitting ? (
                                    <span className="button-loading">
                                        <span className="spinner-border spinner-border-sm"></span>
                                        Submitting...
                                    </span>
                                ) : (
                                    "Submit Warranty Claim"
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default WarrantyClaim;
